type User = {
    firstName?: string | null
    middleName?: string | null
    prefixLastName?: string | null
    lastName?: string | null
}

export const getFullName = ({ firstName, middleName, prefixLastName, lastName }: User): string => {
    return [firstName, middleName, prefixLastName, lastName].filter(Boolean).join(' ')
}

/** Returns either the firstName or lastName */
export const getShortName = ({ firstName, lastName }: User): string => {
    return firstName ?? lastName ?? ''
}
